'use client';
import styles from './cartSyncStatus.module.scss';
import { getCartSync, useCartStore } from '../../model/store';

export function CartSyncStatus() {
  const { needsSync, syncError } = useCartStore();
  if (!needsSync && !syncError) return null;
  return (
    <div className={styles.status} role="status">
      <p>{syncError || 'Сохраняем изменения корзины…'}</p>
      {syncError && (
        <button
          className="link link--underline"
          type="button"
          onClick={() => {
            void getCartSync()
              .flush()
              .catch(() => {});
          }}
        >
          Повторить
        </button>
      )}
    </div>
  );
}
